<p-dialog *ngIf="country"
          header="{{ ('WS_DIRECTORY.COUNTRY.' + (country.id ? 'MODIFY_HEADER' : 'NEW_HEADER')) | translate }}"
          [(visible)]="display"

          [modal]="true"
          [draggable]="false"
          class="admin-dialog">
  <form [formGroup]="countryForm" (submit)="save()">
    <div class="ui-g service-edit-dialog">
      <div class="ui-g-12">
        <div class="ui-g m-b-0">
          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.COUNTRY.TRANSLATION_LANGUAGE' | translate }}</label>
          </div>
          <div class="ui-g-7">
            <p-dropdown [options]="languageItems"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="selectedLocaleCode"></p-dropdown>
          </div>
          <div class="ui-g-12"  *ngFor="let alphaName of country.alphabeticNames ">
            <div class="ui-g m-b-0" *ngIf="alphaName.langCode === selectedLocaleCode">
              <div class="ui-g-5">
                <label>{{ 'WS_DIRECTORY.COUNTRY.ALPHABETIC_NAME' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <input pInputText [ngModelOptions]="{standalone: true}" [(ngModel)]="alphaName.value">
              </div>
            </div>
          </div>
          <div class="ui-g-12" *ngFor="let name of country.names ">
            <div class="ui-g m-b-0" *ngIf="name.langCode === selectedLocaleCode">
              <div class="ui-g-5">
                <label>{{ 'WS_DIRECTORY.COUNTRY.NAME' | translate }}</label>
              </div>
              <div class="ui-g-7">
                <input pInputText [ngModelOptions]="{standalone: true}" [(ngModel)]="name.value">
              </div>
            </div>
          </div>
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.COUNTRY.MODIFY.REGION' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <wsd-select-region [showLabel]="false" [parentForm]="countryForm"></wsd-select-region>
          </div>

          <div class="ui-g-5">
            <label class="no-padding-top">{{'WS_DIRECTORY.COUNTRY.MODIFY.SCOUTING_ESTABLISHED_YEAR' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="countryForm.get('scoutingEstablishedYear')">
              <input pInputText formControlName="scoutingEstablishedYear">
            </gs-extended-input>
          </div>

          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.COUNTRY.MODIFY.ISO2' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="countryForm.get('iso2Code')">
              <input pInputText formControlName="iso2Code">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.COUNTRY.MODIFY.ISO_NUMERIC_CODE' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="countryForm.get('isoNumericCode')">
              <input pInputText formControlName="isoNumericCode">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.COUNTRY.MODIFY.ISO3' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="countryForm.get('iso3Code')">
              <input pInputText formControlName="iso3Code">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.COUNTRY.MODIFY.PHONE_CODE' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="countryForm.get('phoneCode')">
              <input pInputText formControlName="phoneCode">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{ 'SELECT_CURRENCY.LABEL' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <wsd-select-currency-ac [showLabel]="false" [parentForm]="countryForm"></wsd-select-currency-ac>
          </div>
          <div class="ui-g-5">
            <label>{{'WS_DIRECTORY.COUNTRY.MODIFY.CATEGORY' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <gs-extended-input [control]="countryForm.get('category')">
              <input pInputText formControlName="category">
            </gs-extended-input>
          </div>
          <div class="ui-g-5">
            <label>{{'SELECT_MEMBERSHIP.LABEL' | translate}}</label>
          </div>
          <div class="ui-g-7">
            <wsd-select-membership [showLabel]="false" [parentForm]="countryForm"></wsd-select-membership>
          </div>

          <div class="ui-g-5">
            <label>{{ 'WS_DIRECTORY.COUNTRY.FLAG' | translate }}</label>
          </div>
          <div class="ui-g-7" >
            <div class="image-holder">
              <img src="../../../../assets/images/no_image.png" *ngIf="!imageSrc">
              <img [src]="imageSrc" *ngIf="imageSrc">
              <button type="button"
                      pButton
                      (click)="removeImage()"
                      class="ui-button-danger remove"
                      icon="fa fa-times">
              </button>
              <p-fileUpload #fileUpload mode="basic" class="ui-button-info"
                            chooseLabel="{{ 'WS_DIRECTORY.COUNTRY.MODIFY.UPLOAD_FLAG' | translate }}"
                            accept="image/*"
                            [maxFileSize]="5000000"
                            (onSelect)="onSelect($event)">
              </p-fileUpload>
            </div>
          </div>
          <div class="ui-g-5"></div>
          <div class="ui-g-7">
            <button pButton class="ui-button-success inline-block m-r-15"
                    type="submit"
                    [label]="'WS_DIRECTORY.SAVE' | translate"></button>
            <button pButton class="ui-button-secondary inline-block"
                    type="button"
                    [label]="'WS_DIRECTORY.DISCARD' | translate" (click)="discard()"></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
